import { Component, OnInit } from '@angular/core';
import { UploadService } from './../../services/upload/upload.service';
import {AlertsService} from '@core/services/alerts/alerts.service';
import { PeopleService } from '@core/state/people/people.service';
import { Person } from '@core/state/people/person.model';
import {CommonToastsService} from '@core/services/common-toasts/common-toasts.service';
import {Router} from '@angular/router';
import {AlertController} from '@ionic/angular';

@Component({
  selector: 'app-via-wizard-component',
  templateUrl: './via-wizard-component.component.html',
  styleUrls: ['./via-wizard-component.component.scss'],
})
export class ViaWizardComponentComponent implements OnInit {

  constructor(
    public uploadFile: UploadService,
    private alerts: AlertsService,
    public peopleService: PeopleService,
    private commonToasts: CommonToastsService,
    private router: Router,
    private alertCtrl: AlertController,
  ) { }

  ngOnInit() {
    this.peopleService.get('self').subscribe((result: any) => {
      this.person = result.data;
    });
    var todayDate = new Date().toISOString().slice(0, 10);
    this.start_date = todayDate;
    this.end_date = todayDate;
  }

  public person: Person = {} as Person;
  group = 22;
  interest = 0.00;
  interest_lock_period = 0;
  start_date = null;
  end_date = null;
  has_File = false;

  formData = new FormData();



  Echo() {
    console.log("group: " + this.group);
    console.log("interest: " + this.interest);
    console.log("interest_lock_period: " + this.interest_lock_period);
    console.log("start_date: " + this.start_date);
    console.log("end_date: " + this.end_date);
  }

  goToBelastingdienst() {
    window.open('https://mijn.belastingdienst.nl/VIADownload2021/index.html', '_blank');
  }

  async viaUpload() {
    return this.uploadFileFromBrowser();
  }

  async uploadFileFromBrowser() {
    let file = await this.uploadFile.browseFileFromBrowser();

    this.formData.append('file', file as Blob);
    if (!file) {
      console.log("No File");
      this.has_File = false;
    }
    else if (file) {
      console.log(file);
      this.has_File = true;
    }
  }

  SendData() {

    this.formData.append('start_date', this.start_date.toString());
    this.formData.append('end_date', this.end_date.toString());
    this.formData.append('interest', this.interest.toString());
    this.formData.append('interest_lock_period', this.interest_lock_period.toString());

    this.alerts.showLoadingMessage('Uploading');

    this.peopleService.uploadVia(this.person.id, this.formData)
    .subscribe(result => {
      this.doRefresh();
      this.commonToasts.success('Upload VIA Successful!')
      this.router.navigateByUrl('/dashboard/overview');
    }, err => {
      this.doRefresh();
      this.presentAlertAndGoToOverview('Upload failed')
    });
  }

  doRefresh() {
    this.peopleService.get('self').subscribe((result: any) => {
      this.alerts.dismissLoading();
    });
  }

  async presentAlertAndGoToOverview(message: string) {
    const alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          role: 'OK',
          handler: data => {
            alert.dismiss();
            this.router.navigateByUrl('/dashboard/overview');
          }
        }
      ]
    });
    alert.present();
  }
}
